import React, { Component } from 'react'
import SVGInline from 'react-svg-inline'
import Transition from 'react-transition-group/Transition'
import { Trans } from '@lingui/react'
import { Dropdown } from 'client/shared/blocks/dropdown'
import noop from 'lodash/noop'

import './user-layout-switcher.styl'

import GridLayoutIcon from 'client/shared/icons/grid-layout.svg'
import ListLayoutIcon from 'client/shared/icons/list-layout.svg'
import FilterIcon from 'client/shared/icons/filter.svg'

const DROPDOWN_TOP_OFFSET = 20

type Props = {
  layout: string
  content: string
  disableContentSwitcher: boolean
  availableSections: string[]
  onLayoutChange: (arg: string) => void
  onContentChange: (arg: string) => void
}

export class UserLayoutSwitcher extends Component<Props> {
  state = {
    dropdownShown: false,
  }

  toggleDropdown = (e: Event): void => {
    e.preventDefault()
    this.setState({ dropdownShown: !this.state.dropdownShown })
  }

  closeDropdown = (): void => {
    this.setState({ dropdownShown: false })
  }

  render(): JSX.Element {
    return (
      <div className="user-layout-switcher">
        {this.renderContentSwitcher()}
        {this.renderLayoutSwitcher()}
      </div>
    )
  }

  renderLayoutSwitcher(): JSX.Element {
    const { layout } = this.props

    const gridLayoutIndicator = (
      <Transition
        in={layout === 'list'}
        mountOnEnter
        timeout={{
          enter: 200,
          exit: 100,
        }}
      >
        {status => (
          <SVGInline
            className={`user-layout-switcher__icon user-layout-switcher__icon_grid user-layout-switcher__icon_${status}`}
            svg={GridLayoutIcon}
            onClick={() => this.props.onLayoutChange('grid')}
          />
        )}
      </Transition>
    )
    const listLayoutIndicator = (
      <Transition
        in={layout === 'grid'}
        mountOnEnter
        timeout={{
          enter: 200,
          exit: 100,
        }}
      >
        {status => (
          <SVGInline
            className={`user-layout-switcher__icon user-layout-switcher__icon_list user-layout-switcher__icon_${status}`}
            svg={ListLayoutIcon}
            onClick={() => this.props.onLayoutChange('list')}
          />
        )}
      </Transition>
    )

    return (
      <div className="user-layout-switcher__layout-section">
        {gridLayoutIndicator}
        {listLayoutIndicator}
      </div>
    )
  }

  renderContentSwitcher(): JSX.Element {
    const { disableContentSwitcher: disable } = this.props

    const baseIconClass = 'user-layout-switcher__filter-icon'
    const disabledModifier = disable
      ? 'user-layout-switcher__filter-icon_disabled'
      : ''
    const iconClass = `${baseIconClass} ${disabledModifier}`

    return (
      <div className="user-layout-switcher__content-section">
        <span className="user-layout-switcher__filter-icon-wrapper">
          <SVGInline
            className={iconClass}
            svg={FilterIcon}
            onClick={disable ? noop : this.toggleDropdown}
          />
          <Dropdown
            position="top-center"
            offsetTop={DROPDOWN_TOP_OFFSET}
            onClose={this.closeDropdown}
            hidden={!this.state.dropdownShown}
          >
            <div className="user-layout-switcher__dropdown">
              {this.renderDropdownContents()}
            </div>
          </Dropdown>
        </span>
      </div>
    )
  }

  renderDropdownContents(): JSX.Element[] {
    const { content, availableSections } = this.props

    const baseContentOptionClass = 'user-layout-switcher__content-option'

    return availableSections.map((sectionName, index) => {
      const activeModifier =
        sectionName === content ? `${baseContentOptionClass}_active` : ''

      return (
        <div
          key={index}
          className={`${baseContentOptionClass} ${activeModifier}`}
          onClick={() => {
            this.closeDropdown()
            this.props.onContentChange(sectionName)
          }}
        >
          <Trans id={`miscellaneous.${sectionName}`} />
        </div>
      )
    })
  }
}
